import React from "react";
import { Menu, ListItemIcon, MenuItem } from "@mui/material";
import { useNavigate } from "react-router";
import {
  Edit,
  Settings,
  PlayArrow,
  DownloadDoneOutlined,
  HighlightOff,
  BarChart,
  Delete,
} from "@mui/icons-material";
import { usePostContext } from "../../contexts/postContext";

export default function PostItemActions(props) {
  const navigate = useNavigate();
  const {
    activeGridItemActions,
    setActiveGridItemActions,
    setActiveGridItem,
    setShowPublish,
    setShowUnpublish,
    editRoute,
    previewRoute,
    triggerPostDeleteFunction,
    activeGridItem,
    setShowPostSettings,
  } = usePostContext();


  return (
    <>
      <Menu
        id={`video-actions-menu-${activeGridItemActions.id}`}
        open={Boolean(activeGridItemActions.anchorElement)}
        anchorEl={activeGridItemActions.anchorElement}
        onClose={() => {
          setActiveGridItemActions({ anchorElement: null, id: null });
          setActiveGridItem(null);
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        {/* Write actions are gated on the row's has_edit_permission /
            has_delete_permission (backend access('update')/access('delete'));
            without this a user who can only view still saw Edit/Publish/Delete
            and hit a 403 on use. Preview stays available to anyone who can
            open the item. */}
        {activeGridItem?.has_edit_permission && (
          <MenuItem
            onClick={() => {
              navigate(`${editRoute}/${activeGridItemActions.id}`);
            }}
          >
            <ListItemIcon>
              <Edit fontSize="small" />
            </ListItemIcon>
            Edit
          </MenuItem>
        )}

        {activeGridItem?.has_edit_permission && (
          <MenuItem onClick={() => setShowPostSettings(true)}>
            <ListItemIcon>
              <Settings fontSize="small" />
            </ListItemIcon>
            Settings
          </MenuItem>
        )}

        <MenuItem
          onClick={() => {
            window.open(`${previewRoute}/${activeGridItemActions.id}`);
          }}
        >
          <ListItemIcon>
            <PlayArrow fontSize="small" />
          </ListItemIcon>
          Preview
        </MenuItem>
        {activeGridItem?.has_edit_permission && (
          <MenuItem
            onClick={() => {
              setShowPublish(true);
            }}
          >
            <ListItemIcon>
              <DownloadDoneOutlined fontSize="small" />
            </ListItemIcon>
            {activeGridItem?.status === "published" ? "Re-publish" : "Publish"}
          </MenuItem>
        )}

        {activeGridItem?.has_edit_permission &&
          (activeGridItem?.status === "modified" ||
            activeGridItem?.status === "published") && (
            <MenuItem
              onClick={() => {
                setShowUnpublish(true);
              }}
            >
              <ListItemIcon>
                <HighlightOff fontSize="small" />
              </ListItemIcon>
              Unpublish
            </MenuItem>
          )}

        {activeGridItem?.has_edit_permission && (
          <MenuItem>
            <ListItemIcon>
              <BarChart fontSize="small" />
            </ListItemIcon>
            Analytics
          </MenuItem>
        )}

        {activeGridItem?.has_delete_permission && (
          <MenuItem
            onClick={() => {
              triggerPostDeleteFunction(activeGridItemActions.id);
            }}
          >
            <ListItemIcon>
              <Delete fontSize="small" />
            </ListItemIcon>
            Delete
          </MenuItem>
        )}
      </Menu>
    </>
  );
}
